import React from 'react'
type InputIconProps = {
  width?: string
  height?: string
  color?: string
}
const InputIcon = ({
  width = '20',
  color = 'black',
  height = '20',
}: InputIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19 13L19 14.2C19 15.8802 19 16.7202 18.673 17.362C18.3854 17.9265 17.9265 18.3854 17.362 18.673C16.7202 19 15.8802 19 14.2 19L5.8 19C4.11984 19 3.27976 19 2.63803 18.673C2.07354 18.3854 1.6146 17.9265 1.32698 17.362C0.999999 16.7202 0.999999 15.8802 0.999999 14.2L0.999999 13M15 8L10 13M10 13L5 8M10 13L10 1'
        stroke={color}
        strokeWidth='2'
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  )
}

export default InputIcon
